module.exports = require('./helpers/bundle-url').getBundleURL('6WWJZ') + "logo-dark.ba5147f0.svg";